import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BaseController extends Controller {
  @service intl!: Services['intl'];
  @service store!: Services['store'];
  @service router!: Services['router'];
  @service session!: Services['session'];
  @service notifications!: Services['notifications'];

  @service('repositories/account-configuration')
  accountConfigurationRepository!: Services['repositories/account-configuration'];

  @cached
  get currentAccountConfiguration(): ModelRegistry['account-configuration'] {
    return this.accountConfigurationRepository.currentAccountConfiguration;
  }

  @cached
  get defaultTimezone(): string {
    return this.currentAccountConfiguration.timezone;
  }

  @cached
  get currentUser(): ModelRegistry['user'] {
    return this.session.currentUser as ModelRegistry['user'];
  }

  @cached
  get currentRouteName(): string {
    return this.router.currentRouteName ?? '';
  }

  @cached
  get isXCalendar(): boolean {
    return this.currentRouteName.startsWith('xcalendar');
  }
}
